import React from 'react';
import { Routes, Route } from "react-router-dom";

// Layouts
import NonAuthLayout from "../Layouts/NonAuthLayout";
import VerticalLayout from "../Layouts/index";

// Routes
import { authProtectedRoutes, publicRoutes } from "./allRoutes";
import AuthProtected from './AuthProtected';
import DefaultRedirect from './DefaultRedirect';

// Hướng dẫn Sử dụng — trang tài liệu tĩnh nhúng qua iframe, hiển thị full màn hình nên đặt route thô,
// không bọc qua VerticalLayout (sidebar/header quản trị) hay NonAuthLayout (khung form đăng nhập).
import HuongDanSuDung from '../pages/HuongDanSuDung';

/**
 * Router chính của ứng dụng
 * - Public routes: Không cần authentication (login, forgot password, etc.)
 * - Protected routes: Yêu cầu authentication
 */
const Index = () => {
    return (
        <React.Fragment>
            <Routes>
                {/* Root path - redirect tới trang đầu tiên mà quyền hiện tại được phép xem (DefaultRedirect,
                    xem mục 9, README_SERCURITY.md) — AuthProtected sẽ handle redirect về login nếu chưa authenticate */}
                <Route
                    path="/"
                    element={
                        <AuthProtected>
                            <DefaultRedirect />
                        </AuthProtected>
                    }
                />

                {/* Hướng dẫn Sử dụng - trang tĩnh full màn hình, không qua layout nào */}
                <Route path="/huong-dan" element={<HuongDanSuDung />} />

              {/* Public routes - Không yêu cầu authentication */}
                <Route>
                    {publicRoutes.map((route, idx) => (
                        <Route
                            path={route.path}
                            element={
                                <NonAuthLayout>
                                    {route.component}
                                </NonAuthLayout>
                            }
                            key={idx}
                        />
                    ))}
                </Route>

                {/* Protected routes - Yêu cầu authentication */}
                <Route>
                    {authProtectedRoutes.map((route, idx) => (
                        <Route
                            path={route.path}
                            element={
                                <AuthProtected>
                                    <VerticalLayout>{route.component}</VerticalLayout>
                                </AuthProtected>}
                            key={idx}
                        />
                    ))}
                </Route>

                {/* Catch-all route for 404 - redirect về login nếu chưa auth, về trang đầu tiên được phép xem nếu đã auth */}
                <Route
                    path="*"
                    element={
                        <AuthProtected>
                            <DefaultRedirect />
                        </AuthProtected>
                    }
                />
            </Routes>
        </React.Fragment>
    );
};

export default Index;